// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
    apiKey: "AIzaSyB-T3C4YYr7lJmsgRY3DR2ajU7QkZF4BFQ",
    authDomain: "express-clean.firebaseapp.com",
    projectId: "express-clean",
    storageBucket: "express-clean.appspot.com",
    messagingSenderId: "500581469015",
    appId: "1:500581469015:web:5cb44ffcfb338313474c12",
    measurementId: "G-EXKPZJTZJ5"
};
export default firebaseConfig;